import { type CSSProperties, type NestedCSSProperties } from 'typestyle/lib/types';
import { type FlexDirection, type FlexWrap } from './flex.component';

const getItemProperties = (
  flexDirection: FlexDirection,
  spacing?: number,
  wrapSpacing?: number,
  justifyContent?: string,
): CSSProperties => {
  const result: CSSProperties = {};

  if (spacing !== undefined && flexDirection.startsWith('column')) {
    result.marginBottom = spacing;
  }

  if (spacing !== undefined && flexDirection.startsWith('row')) {
    result.marginRight = spacing;
  }

  if (wrapSpacing !== undefined) {
    result.marginTop = wrapSpacing;
  }

  if (justifyContent === 'stretch') {
    result.flexGrow = 1;
    result.flexShrink = 1;
    result.flexBasis = 0;
  }

  return result;
};

const flex = (
  flexDirection: FlexDirection,
  spacing?: number,
  wrapSpacing?: number,
  alignItems?: string,
  justifyContent?: string,
  flexWrap?: FlexWrap,
): NestedCSSProperties => ({
  display: 'flex',
  flexDirection,
  alignItems,
  justifyContent,
  flexWrap,
  marginTop: wrapSpacing !== undefined ? -wrapSpacing : undefined,
  $nest: {
    '& > *': getItemProperties(flexDirection, spacing, wrapSpacing, justifyContent),
    '& > *:last-child': getItemProperties(flexDirection, spacing !== undefined ? 0 : undefined, wrapSpacing, justifyContent),
  },
});

export default flex;
